module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContainer"
  }, [_c('div', {
    staticClass: "stock-text markdown-text"
  }, [_c('h1', [_vm._v("Design Guide")]), _vm._v(" "), _c('h1', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#49c15d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Primary Light"), _c('br'), _vm._v("\r\n          #49c15d\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#388e3c"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Primary"), _c('br'), _vm._v("\r\n          #388e3c\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#245b27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Primary Dark"), _c('br'), _vm._v("\r\n          #245b27\r\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#f9ae45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Accent"), _c('br'), _vm._v("\r\n          #f9ae45\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#c2c5bb"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Base"), _c('br'), _vm._v("\r\n          #c2c5bb\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#f55448"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Error"), _c('br'), _vm._v("\r\n          #f55448\r\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#333333"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Primary Text"), _c('br'), _vm._v("\r\n          #333333\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#949494"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Grey"), _c('br'), _vm._v("\r\n          #949494\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swatch"
  }, [_c('div', {
    staticClass: "swatch-body",
    staticStyle: {
      "background-color": "#eeeeee"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swatch-text"
  }, [_vm._v("\r\n          Light Grey"), _c('br'), _vm._v("\r\n          #eeeeee\r\n        ")])])]), _vm._v(" "), _c('h1', [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "typeface"
  }, [_c('div', {
    staticClass: "typeface-body header-sample"
  }, [_vm._v("Header 1")]), _vm._v(" "), _c('div', {
    staticClass: "typeface-text"
  }, [_vm._v("34px (2.125rem)")])]), _vm._v(" "), _c('div', {
    staticClass: "typeface"
  }, [_c('div', {
    staticClass: "typeface-body"
  }, [_vm._v("Paragraph Text")]), _vm._v(" "), _c('div', {
    staticClass: "typeface-text"
  }, [_vm._v("16px")])]), _vm._v(" "), _c('div', {
    staticClass: "typeface"
  }, [_c('div', {
    staticClass: "typeface-body caption-sample"
  }, [_vm._v("Caption")]), _vm._v(" "), _c('div', {
    staticClass: "typeface-text"
  }, [_vm._v("12px (0.75rem), grey")])]), _vm._v(" "), _c('h1', [_vm._v("Buttons")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Default")]), _vm._v(" "), _c('button', {
    staticClass: "button dark"
  }, [_vm._v("Dark")]), _vm._v(" "), _c('button', {
    staticClass: "button outline"
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("directions_run")]), _vm._v(" Icon Button\r\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button outline"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("face")]), _vm._v(" Icon Button\r\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("\r\n      Icon only: \r\n      "), _c('button', {
    staticClass: "button iconOnly"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("send")])]), _vm._v(" "), _c('button', {
    staticClass: "button dark iconOnly"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("fastfood")])]), _vm._v(" "), _c('button', {
    staticClass: "button outline iconOnly"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("hot_tub")])])]), _vm._v(" "), _c('h1', [_vm._v("Markdown Styles")]), _vm._v(" "), _c('p', [_vm._v("This is a paragraph text.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("List item 1")]), _vm._v(" "), _c('li', [_vm._v("List item 2")]), _vm._v(" "), _c('li', [_vm._v("List item 3")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61426208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/designguide.vue
// module id = 70
// module chunks = 0